/**
 * What the header search box was given. A reservation code (`r-123`, `R123`,
 * `#123`) opens that reservation; a bare number could be a reservation or a
 * user id, so both are offered; anything else is a user search (name, email,
 * phone), which the server also matches against ids.
 */
export interface ILookup {
  /** The reservation id to offer, if the text can be one. */
  reservationId?: number;
  /** True when the text is unmistakably a reservation code, so "not found" is worth saying. */
  reservationOnly: boolean;
  /** The text to search users by, or undefined when it's too short or a reservation code. */
  userTerm?: string;
}

const RESERVATION_CODE = /^(?:r\s*-?\s*|#\s*)(\d{1,9})$/i;
const NUMBER = /^\d{1,9}$/;

export function parseLookup(text: string | null | undefined): ILookup {
  const q = (text ?? '').trim();
  const code = q.match(RESERVATION_CODE);
  if (code) return { reservationId: Number(code[1]), reservationOnly: true };
  if (NUMBER.test(q)) return { reservationId: Number(q), reservationOnly: false, userTerm: q };
  return { reservationOnly: false, userTerm: q.length >= 2 ? q : undefined };
}
